"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  BookNextPage: ['book-next-page', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.752,19.579C13.639,20.305,12,22.125,12,22.125V4.712S9.545,1.985,1.268,1.875a.506.506,0,0,0-.366.15.522.522,0,0,0-.152.369V18.769a.515.515,0,0,0,.5.519C9.543,19.4,12,22.125,12,22.125', 'M12,4.712s2.455-2.727,10.732-2.837a.506.506,0,0,1,.366.15.522.522,0,0,1,.152.369V14.625', 'M18.75,19.564v-4.39a.557.557,0,0,1,.563-.549H23.25Z']],
  BookFlipPage: ['book-flip-page', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,4.144a31.156,31.156,0,0,1,4.732-.394.517.517,0,0,1,.366.144.5.5,0,0,1,.152.356V20.018a.505.505,0,0,1-.5.5C14.457,20.621,12,23.25,12,23.25V6.482S9.545,3.856,1.268,3.75A.517.517,0,0,0,.9,3.894.5.5,0,0,0,.75,4.25V20.018a.505.505,0,0,0,.5.5C9.543,20.621,12,23.25,12,23.25', 'M12,22.757a6.035,6.035,0,0,1,1.636-3.448A8.228,8.228,0,0,1,18,16.846V1.243a.481.481,0,0,0-.228-.4.6.6,0,0,0-.494-.066,7.8,7.8,0,0,0-3.642,2.277A6.035,6.035,0,0,0,12,6.5']],
  BookOpen1: ['book-open-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,4.57A22.371,22.371,0,0,0,1.285,1.293a.514.514,0,0,0-.376.141A.507.507,0,0,0,.75,1.8V18.542a.512.512,0,0,0,.49.511,13.062,13.062,0,0,1,9.781,2.559,1.954,1.954,0,0,0,.98.135', 'M12,4.57A22.371,22.371,0,0,1,22.715,1.293a.514.514,0,0,1,.376.141.507.507,0,0,1,.159.369V18.542a.512.512,0,0,1-.49.511,13.062,13.062,0,0,0-9.781,2.559,1.954,1.954,0,0,1-.98.135', 'M12 4.57L12 21.757', 'M2.25,18.974V22.2a.511.511,0,0,0,.623.5A44.739,44.739,0,0,1,12,21.758a39.581,39.581,0,0,1,8.582.937.513.513,0,0,0,.623-.5V18.958']],
  BookEdit: ['book-edit', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.249,23.25H3A2.25,2.25,0,0,1,.751,21', 'M18.751,9V1.5A.75.75,0,0,0,18,.75H3.751a3,3,0,0,0-3,3V21A2.25,2.25,0,0,1,3,18.75H9', 'M22.629,14.87,15,22.5l-3.75.75L12,19.5l7.63-7.63a2.114,2.114,0,0,1,2.992,0l.008.008A2.116,2.116,0,0,1,22.629,14.87Z']],
  BookPlay: ['book-play', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h15A.75.75,0,0,0,21,18V1.5a.75.75,0,0,0-.75-.75Z', 'M19.5 23.25L19.5 18.75', 'M7.5,7.125v5.912a.749.749,0,0,0,1.085.67L16.5,9.75,8.538,6.433A.749.749,0,0,0,7.5,7.125Z']],
  BookBookPages: ['book-book-pages', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,21.513a1.5,1.5,0,0,1-1.9,1.446L4.1,20.042A1.5,1.5,0,0,1,3,18.6V2.487A1.5,1.5,0,0,1,4.9,1.041L15.4,4.432a1.5,1.5,0,0,1,1.1,1.445Z', 'M4.5.987h15a1.5,1.5,0,0,1,1.5,1.5v15.75a1.5,1.5,0,0,1-1.5,1.5h-3']],
  BookAddress1: ['book-address-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h15A.75.75,0,0,0,21,18V1.5a.75.75,0,0,0-.75-.75Z', 'M19.5 23.25L19.5 18.75', 'M7.5,15.75a4.5,4.5,0,0,1,9,0Z', 'M9.000 8.250 A3.000 3.000 0 1 0 15.000 8.250 A3.000 3.000 0 1 0 9.000 8.250 Z']],
  BookDownload1: ['book-download-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,18.75H5.25A2.25,2.25,0,0,1,3,16.5', 'M21 18.75L18 18.75', 'M15,14.25h5.25A.75.75,0,0,0,21,13.5V1.5a.75.75,0,0,0-.75-.75H6a3,3,0,0,0-3,3V16.5a2.25,2.25,0,0,1,2.25-2.25H9', 'M19.5 18.75L19.5 14.25', 'M9 20.25L12 23.25 12 11.25', 'M15 20.25L12 23.25']],
  BookDownload: ['book-download', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,23.25h-6A2.25,2.25,0,0,1,1.5,21', 'M19.5,8.25V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H7.5', 'M10.500 17.250 A6.000 6.000 0 1 0 22.500 17.250 A6.000 6.000 0 1 0 10.500 17.250 Z', 'M16.5 14.25L16.5 20.25', 'M16.5 20.25L14.25 18', 'M16.5 20.25L18.75 18']],
  BookClose1: ['book-close-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,5.523v15a2.25,2.25,0,0,0,2.25,2.25,2.207,2.207,0,0,0,.392-.039l9.406-1.682A3.584,3.584,0,0,0,19.5,17.524V7.024a1.256,1.256,0,0,0-1.476-1.236L7.147,7.738a2.25,2.25,0,1,1-.794-4.429L17.972,1.227', 'M16.37 1.514L18.512 5.797']],
  BookCloseBookmark: ['book-close-bookmark', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,2.25h1.5A1.5,1.5,0,0,1,21,3.75v18a1.5,1.5,0,0,1-1.5,1.5H4.5A1.5,1.5,0,0,1,3,21.75v-18a1.5,1.5,0,0,1,1.5-1.5H12', 'M7.5 2.25L7.5 23.25', 'M18,12.75l-3-3-3,3V2.25A1.5,1.5,0,0,1,13.5.75h3A1.5,1.5,0,0,1,18,2.25Z']],
  BookCloseBookmark1: ['book-close-bookmark-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M12,2.25H6a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h15A.75.75,0,0,0,21,18V3a.75.75,0,0,0-.75-.75H18', 'M19.5 23.25L19.5 18.75', 'M18,12.75l-3-3-3,3V2.25A1.5,1.5,0,0,1,13.5.75h3A1.5,1.5,0,0,1,18,2.25Z']],
  BookHeart: ['book-heart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,23.25H3.75A2.25,2.25,0,0,1,1.5,21', 'M19.5,9.75V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h4.5', 'M16.5,23.25l-5.114-5.335a3.025,3.025,0,0,1-.567-3.492h0a3.026,3.026,0,0,1,4.846-.786l.835.835.835-.835a3.025,3.025,0,0,1,4.845.786h0a3.025,3.025,0,0,1-.566,3.492Z']],
  BookLibraryShelf: ['book-library-shelf', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.25,19.5a3.75,3.75,0,0,1-7.5,0V6.75', 'M15.75,19.5a3.75,3.75,0,0,1-7.5,0', 'M23.25,6.75V19.5a3.75,3.75,0,0,1-7.5,0', 'M8.25,6.75a3.75,3.75,0,0,1-7.5,0v-6', 'M15.75,6.75a3.75,3.75,0,0,1-7.5,0', 'M23.25.75v6a3.75,3.75,0,0,1-7.5,0', 'M4.5 0.75L4.5 7.5', 'M12 0.75L12 7.5', 'M19.5 0.75L19.5 7.5', 'M8.25 19.5L8.25 0.75', 'M15.75 19.5L15.75 0.75']],
  BookLibrary1: ['book-library-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-5.663 7.372) rotate(-21.323)'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M23.25 12L0.75 12', 'M12.75 3.75H16.5V12H12.75z', 'M16.5 6H20.25V12H16.5z', 'M4.5 15H8.25V23.25H4.5z', 'M8.25 15H12V23.25H8.25z', 'M14.872 14.601H18.622V22.851H14.872z']],
  BookImage: ['book-image', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.25,23.25H3A2.25,2.25,0,0,1,.75,21', 'M18.75,8.25V1.5A.75.75,0,0,0,18,.75H3.75a3,3,0,0,0-3,3V21A2.25,2.25,0,0,1,3,18.75H8.25', 'M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M15.375,14.25a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M23.25,21l-2.391-3.587A.75.75,0,0,0,19.62,17.4l-2,2.851-1.236-.989a.751.751,0,0,0-1.093.17L12.75,23.25']],
  BookPin: ['book-pin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.875,23.25H3.375A2.25,2.25,0,0,1,1.125,21', 'M19.125,8.25V1.5a.75.75,0,0,0-.75-.75H4.125a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h7.5', 'M18.375,15.449a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M18.375,11.324a4.5,4.5,0,0,1,4.5,4.5c0,1.921-2.688,5.576-3.909,7.138a.75.75,0,0,1-1.182,0c-1.221-1.561-3.909-5.217-3.909-7.138A4.5,4.5,0,0,1,18.375,11.324Z']],
  BookOpen2: ['book-open-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.458,21.269a1.6,1.6,0,0,0,1.085,0,13.66,13.66,0,0,1,8.7-.448,1.607,1.607,0,0,0,2.006-1.559V4.928A1.607,1.607,0,0,0,22.129,3.4a13.878,13.878,0,0,0-9.586.2,1.61,1.61,0,0,1-1.085,0,13.881,13.881,0,0,0-9.587-.2A1.607,1.607,0,0,0,.75,4.928V19.262a1.607,1.607,0,0,0,2.006,1.559A13.663,13.663,0,0,1,11.458,21.269Z', 'M12 3.682L12 21.364']],
  BookOpen: ['book-open', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13,22.906a16.989,16.989,0,0,1,8.856-3.89,1.6,1.6,0,0,0,1.391-1.587V2.365a1.613,1.613,0,0,0-1.835-1.6A17.077,17.077,0,0,0,13,4.6,1.636,1.636,0,0,1,11,4.6,17.077,17.077,0,0,0,2.585.767,1.613,1.613,0,0,0,.75,2.365V17.429a1.6,1.6,0,0,0,1.391,1.587A16.989,16.989,0,0,1,11,22.906,1.633,1.633,0,0,0,13,22.906Z', 'M12 4.938L12 23.249']],
  BookMusic: ['book-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,23.25H3A2.25,2.25,0,0,1,.75,21', 'M18.75,9.75V1.5A.75.75,0,0,0,18,.75H3.75a3,3,0,0,0-3,3V21A2.25,2.25,0,0,1,3,18.75H9.75', 'M12.000 21.375 A1.875 1.875 0 1 0 15.750 21.375 A1.875 1.875 0 1 0 12.000 21.375 Z', 'M19.500 19.125 A1.875 1.875 0 1 0 23.250 19.125 A1.875 1.875 0 1 0 19.500 19.125 Z', 'M15.75,21.375V14.581a1.5,1.5,0,0,1,1.026-1.423l4.5-1.25a1.5,1.5,0,0,1,1.974,1.423v5.794']],
  BookSearch: ['book-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25,23.25H3.75A2.25,2.25,0,0,1,1.5,21', 'M19.5,8.25V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H7.5', 'M9.750 15.750 A5.250 5.250 0 1 0 20.250 15.750 A5.250 5.250 0 1 0 9.750 15.750 Z', 'M22.5 23.25L18.712 19.462']],
  BookTarget: ['book-target', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25,23.25H3.75A2.25,2.25,0,0,1,1.5,21', 'M19.5,9.75V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H9', 'M12.000 18.000 A5.250 5.250 0 1 0 22.500 18.000 A5.250 5.250 0 1 0 12.000 18.000 Z', 'M17.25,17.625a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0']],
  BookSound: ['book-sound', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,21.75H3A2.25,2.25,0,0,1,.75,19.5', 'M3.75,2.25a3,3,0,0,0-3,3V19.5A2.25,2.25,0,0,1,3,17.25H15a.75.75,0,0,0,.75-.75V3A.75.75,0,0,0,15,2.25Z', 'M14.25 21.75L14.25 17.25', 'M7.5,7.5H6A2.25,2.25,0,0,0,6,12H7.5l3.75,2.25v-9Z', 'M21.273,6a6.75,6.75,0,0,1,0,9.546', 'M19.152,8.121a3.752,3.752,0,0,1,0,5.3']],
  BookStar1: ['book-star-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,23.25H3.75A2.25,2.25,0,0,1,1.5,21', 'M19.5,9V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H9', 'M17.2,11.68,18.738,15h3a.735.735,0,0,1,.518,1.283l-2.6,2.563L21.1,22.162a.786.786,0,0,1-1.119.982L16.49,21.183,13,23.144a.786.786,0,0,1-1.119-.982l1.443-3.313-2.6-2.563A.734.734,0,0,1,11.238,15h3l1.544-3.323A.8.8,0,0,1,17.2,11.68Z']],
  Phonebook: ['phonebook', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h15A.75.75,0,0,0,21,18V1.5a.75.75,0,0,0-.75-.75Z', 'M19.5 23.25L19.5 18.75', 'M11.748,13.681,14.159,11.3a1.5,1.5,0,0,1,2.121,0l.531.531a1.5,1.5,0,0,1,0,2.121l-.46.46a1.5,1.5,0,0,1-1.425.4l-.872-.218a9.478,9.478,0,0,1-6.9-6.9L6.94,6.824A1.5,1.5,0,0,1,7.335,5.4l.46-.46a1.5,1.5,0,0,1,2.121,0l.531.53a1.5,1.5,0,0,1,0,2.121l-2.386,2.4']],
  BookUpload: ['book-upload', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,23.25h-6A2.25,2.25,0,0,1,1.5,21', 'M19.5,8.25V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H7.5', 'M10.500 17.250 A6.000 6.000 0 1 0 22.500 17.250 A6.000 6.000 0 1 0 10.500 17.250 Z', 'M16.5 20.25L16.5 14.25', 'M16.5 14.25L14.25 16.5', 'M16.5 14.25L18.75 16.5']],
  BookLibrary: ['book-library', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-3.623 7.281) rotate(-20.824)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.384,23.25H2.366a1.5,1.5,0,0,1-1.5-1.5V7.5A1.5,1.5,0,0,1,2.366,6H4.384', 'M15.750 3.750 L20.250 3.750 L20.250 23.250 L15.750 23.250 Z', 'M6.866 0.750 L12.866 0.750 L12.866 23.250 L6.866 23.250 Z', 'M9.866 3.75L9.866 15.75', 'M9.866,19.125a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0']],
  BookClose: ['book-close', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13,22.906a16.989,16.989,0,0,1,8.856-3.89,1.6,1.6,0,0,0,1.391-1.587V6.21a1.611,1.611,0,0,0-1.835-1.6A17.067,17.067,0,0,0,13,8.442a1.636,1.636,0,0,1-2.006,0A17.067,17.067,0,0,0,2.585,4.613,1.611,1.611,0,0,0,.75,6.21V17.429a1.6,1.6,0,0,0,1.391,1.587A16.989,16.989,0,0,1,11,22.906,1.633,1.633,0,0,0,13,22.906Z', 'M20.02.75A17.679,17.679,0,0,0,13,4.315a1.636,1.636,0,0,1-2.006,0A17.668,17.668,0,0,0,3.984.751', 'M12 8.784L12 23.247']],
  BookLibrary2: ['book-library-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-1.261 2.745) rotate(-8.267)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 0.750 L8.250 0.750 L8.250 18.000 L2.250 18.000 Z', 'M8.250 0.750 L14.250 0.750 L14.250 18.000 L8.250 18.000 Z', 'M16.110 2.224 L20.610 2.224 L20.610 17.974 L16.110 17.974 Z', 'M.75,19.5A1.5,1.5,0,0,0,2.25,21h19.5a1.5,1.5,0,0,0,0-3H2.25A1.5,1.5,0,0,0,.75,19.5Z', 'M3 21L3 23.25', 'M21 21L21 23.25']],
  BookOpenText: ['book-open-text', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,22.125V4.712S9.545,1.985,1.268,1.875a.506.506,0,0,0-.366.15.522.522,0,0,0-.152.369V18.769a.515.515,0,0,0,.5.519C9.543,19.4,12,22.125,12,22.125', 'M9,11.18a21.258,21.258,0,0,0-5.26-1.055', 'M9,15.375A21.258,21.258,0,0,0,3.74,14.32', 'M15,11.18a21.258,21.258,0,0,1,5.26-1.055', 'M15,15.375a21.258,21.258,0,0,1,5.26-1.055', 'M12,22.125V4.712s2.455-2.727,10.732-2.837a.506.506,0,0,1,.366.15.522.522,0,0,1,.152.369V18.769a.515.515,0,0,1-.5.519C14.457,19.4,12,22.125,12,22.125']],
  BookClose2: ['book-close-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h15A.75.75,0,0,0,21,18V1.5a.75.75,0,0,0-.75-.75Z', 'M19.5 23.25L19.5 18.75']],
  BookBookmark: ['book-bookmark', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 4.057L12 21.739', 'M15.49,3.184a16.546,16.546,0,0,0-2.947.782,1.61,1.61,0,0,1-1.085,0,13.881,13.881,0,0,0-9.587-.2A1.607,1.607,0,0,0,.75,5.3V19.637A1.607,1.607,0,0,0,2.756,21.2a13.663,13.663,0,0,1,8.7.448,1.6,1.6,0,0,0,1.085,0,13.66,13.66,0,0,1,8.7-.448,1.608,1.608,0,0,0,2.006-1.559V5.3A1.607,1.607,0,0,0,22.129,3.77a16.908,16.908,0,0,0-2.365-.576', 'M19.875,11.261l-2.25-2.25-2.25,2.25v-7.5a1.5,1.5,0,0,1,1.5-1.5h1.5a1.5,1.5,0,0,1,1.5,1.5Z']],
  BookAddress: ['book-address', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h15A.75.75,0,0,0,21,18V1.5a.75.75,0,0,0-.75-.75Z', 'M19.5 23.25L19.5 18.75', 'M7.5,15.75a4.5,4.5,0,0,1,9,0Z', 'M9.000 8.250 A3.000 3.000 0 1 0 15.000 8.250 A3.000 3.000 0 1 0 9.000 8.250 Z']],
  BookShare: ['book-share', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,23.25h-9A2.25,2.25,0,0,1,1.5,21', 'M19.5,8.25V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H7.5', 'M10.500 18.000 A2.250 2.250 0 1 0 15.000 18.000 A2.250 2.250 0 1 0 10.500 18.000 Z', 'M18.000 21.000 A2.250 2.250 0 1 0 22.500 21.000 A2.250 2.250 0 1 0 18.000 21.000 Z', 'M18.000 13.500 A2.250 2.250 0 1 0 22.500 13.500 A2.250 2.250 0 1 0 18.000 13.500 Z', 'M14.674 16.845L18.324 14.655', 'M14.838 18.835L18.162 20.165']],
  BookStar: ['book-star', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,23.25H3.75A2.25,2.25,0,0,1,1.5,21', 'M19.5,9V1.5a.75.75,0,0,0-.75-.75H4.5a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H9', 'M17.2,11.68,18.738,15h3a.735.735,0,0,1,.518,1.283l-2.6,2.563L21.1,22.162a.786.786,0,0,1-1.119.982L16.49,21.183,13,23.144a.786.786,0,0,1-1.119-.982l1.443-3.313-2.6-2.563A.734.734,0,0,1,11.238,15h3l1.544-3.323A.8.8,0,0,1,17.2,11.68Z']],
  Phonebook1: ['phonebook-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25h15A.75.75,0,0,0,21,18V1.5a.75.75,0,0,0-.75-.75Z', 'M19.5 23.25L19.5 18.75', 'M11.748,13.681,14.159,11.3a1.5,1.5,0,0,1,2.121,0l.531.531a1.5,1.5,0,0,1,0,2.121l-.46.46a1.5,1.5,0,0,1-1.425.4l-.872-.218a9.478,9.478,0,0,1-6.9-6.9L6.94,6.824A1.5,1.5,0,0,1,7.335,5.4l.46-.46a1.5,1.5,0,0,1,2.121,0l.531.53a1.5,1.5,0,0,1,0,2.121l-2.386,2.4']],
  BookOpenBookmark: ['book-open-bookmark', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,22.8V5.387S9.545,2.66,1.268,2.55A.514.514,0,0,0,.9,2.7a.526.526,0,0,0-.152.37V19.444a.516.516,0,0,0,.5.52C9.543,20.071,12,22.8,12,22.8', 'M9,11.855A21.258,21.258,0,0,0,3.74,10.8', 'M9,16.05A21.311,21.311,0,0,0,3.74,15', 'M15,11.855A21.258,21.258,0,0,1,20.26,10.8', 'M15,16.05A21.311,21.311,0,0,1,20.26,15', 'M20.26,2.67c.76-.066,1.582-.108,2.472-.12a.514.514,0,0,1,.366.15.526.526,0,0,1,.152.37V19.444a.516.516,0,0,1-.5.52C14.457,20.071,12,22.8,12,22.8', 'M12,22.8V5.387s1.143-1.27,4.5-2.111', 'M20.25,7.8V1.2a24.031,24.031,0,0,0-3.75.6v6l1.875-1.5Z']]
};
exports["default"] = _default;